class HTTPException extends Error {
    constructor(message, code, stack=null)
    {
        super(message);
        this.code = code;
        this.stack = stack;
    }
}

export default HTTPException;